enum CampaignRecurrence {
  OneTime = 'one-time',
  Ongoing = 'ongoing',
}

enum CampaignTactic {
  Prospecting = 'prospecting',
  Retargeting = 'retargeting',
}

enum CampaignMetric {
  ClickTroughRate = 'ctc',
  Conversions = 'conv',
  CompletionRate = 'vcr',
  Custom = 'custom',
}

enum CampaignUpdateFrequency {
  Daily = 'day',
  Weekly = 'week',
  Monthly = 'month',
  Quarterly = 'quarter',
  Other = 'other',
}

enum CampaignSupportedSportType {
  Football = 'football',
  Basketball = 'basketball',
  Hockey = 'hockey',
  Baseball = 'baseball',
  Other = 'other',
}

enum CampaignSportComponent {
  LiveScore = 'live-score',
  WonLost = 'won-lost',
  WinningLosing = 'winning-loosing',
  CountDownDays = 'countdown-days',
  CountDownTime = 'countdown-time',
}

enum CampaignWeatherCondition {
  Temperature = 'temperature',
  Humidity = 'humidity',
  WindSpeed = 'wind-speed',
  WindAngle = 'wind-angle',
  Clouds = 'clouds',
  Rain = 'rain',
  Snow = 'snow',
  UVIndex = 'uv-index',
  AirQualityIndex = 'air-quality-index',
  WeatherCodes = 'weather-codes',
}

enum CampaignOptimizationKPI {
  None = 'none',
  Conversions = 'conversions',
  Clicks = 'clicks',
  CTC = 'ctc',
  VideoCompletion = 'video-complation',
  Other = 'other',
}

enum CampaignMockupType {
  Still = 'still',
  Render = 'render',
  Template = 'template',
}

enum CampaignOptimizationStrategy {
  OneWinning = 'one-winning',
  ReducedServing = 'reduced-serving',
}

export {
  CampaignRecurrence,
  CampaignTactic,
  CampaignUpdateFrequency,
  CampaignSupportedSportType,
  CampaignSportComponent,
  CampaignWeatherCondition,
  CampaignOptimizationKPI,
  CampaignMockupType,
  CampaignMetric,
  CampaignOptimizationStrategy,
};
